import { Injectable } from '@angular/core'
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { of, throwError, Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { NotificationBuilder } from '../shared/notificationBuilder';


interface PostResponse {
    success: boolean;
    message: any;
    error: HttpErrorResponse | null;
  }

@Injectable()
export class HttpService {
    constructor(private http: HttpClient, private notificationBuilder: NotificationBuilder) {
    }

    public post(apiUrl: string, formData: any): Observable<PostResponse> {
        return this.http.post<any>(apiUrl, formData).pipe(
          map(response => {
            // If the response has a 'success' status, return an object with success true and the message
            if (response.success) {
              return { success: true, message: response.message, error: null };
            } else {
              // If the response indicates an error (but not a failed request), return success false and the error message
              return { success: false, message: null, error: new HttpErrorResponse({ error: response.error }) };
            }
          }),
          catchError((error: HttpErrorResponse) => {
            // In case of a failed request, return an object with success false and the error
            return of({ success: false, message: null, error: error });
          })
        );
      }
}
